import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { CoreService } from "../../shared/services/core.service";
import { LoginService } from "../../shared/services/login.service";
import { Merchant } from "src/app/shared/models/merchant";
import { LoginPagemodel } from "src/app/shared/pageModels/loginPage";
import { OrderAppType } from "src/app/shared/helpers/helper.common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { GuestloginComponent } from "./Guest_login/guestlogin.component";
import { FormsModule } from "@angular/forms";
import { NgStyle, AsyncPipe } from "@angular/common";
import { Subscription } from "rxjs";
import { User } from "../../shared/models/Userverify.model";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  standalone: true,
  imports: [NgStyle, FormsModule, RouterLink, GuestloginComponent, AsyncPipe],
})

// Import required modules and classes
export class LoginComponent implements OnInit, OnDestroy, AfterViewInit {
  // ViewChild to reference the errorinfo element in the template
  @ViewChild("errorinfo", { static: true }) private errorinfo: any;
  // Observable for Merchant data
  Merchant$ = this.coreService.Merchant$;
  // Variable to store currentMerchant data
  currentMerchant: Merchant | null = null;
  // Instance of LoginPagemodel to manage page model data
  pageModel: LoginPagemodel;
  // Boolean flag to indicate if GuestLogin is true or false
  GuestLogin: Boolean = false;
  // Subscription to manage the observable subscription
  subscription: Subscription | null = null;

  temp_user: User | null = null;

  // Constructor to initialize class dependencies and pageModel
  constructor(
    private router: Router,
    private coreService: CoreService,
    private authenticationService: LoginService,
    private modalService: NgbModal,
  ) {
    this.pageModel = new LoginPagemodel();
  }

  // Lifecycle hook: ngOnDestroy
  ngOnDestroy(): void {
    // Unsubscribe from the subscription to avoid memory leaks
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // Lifecycle hook: ngOnInit
  ngOnInit() {
    // Auto-reload the page when navigating to /login
    if (!window.location.search.includes("reloaded=true")) {
      const newUrl =
        window.location.href +
        (window.location.href.includes("?") ? "&" : "?") +
        "reloaded=true";
      window.location.href = newUrl;
    }
  }

  // Lifecycle hook: ngAfterViewInit
  ngAfterViewInit() {
    // Subscribe to the Merchant$ observable to get data from the server
    this.subscription = this.Merchant$.subscribe((data) => {
      // Check if data is available and it's not a multi_outlet
      if (data && !data.multi_outlet) {
        // Update currentMerchant with data from the server
        this.currentMerchant = data;

        // Show the login information popup to users who come to the login page for the first time
        if (!sessionStorage.getItem("isfirsttimelogin")) {
          // this.modalService.open(this.errorinfo, { scrollable: true });
          // Hide the login information popup for the next time
          sessionStorage.setItem("isfirsttimelogin", "1");
        }
      }
    });
  }

  // Method to attempt login using the provided user credentials
  attemplogin(user: any) {
    // Check if the user form is valid
    if (!user.valid) {
      return;
    }

    // Call the authentication service to perform the login
    this.authenticationService
      .login(
        user.form.value.txtusername,
        user.form.value.txtpassword,
        OrderAppType.webapp,
      )
      .subscribe(
        (resp) => {
          // Handle the response data after login
          var data = resp.data;
          if (data.success) {
            // Store user details in local storage and emit data using UserSub subject from coreService
            localStorage.setItem("currentUser", JSON.stringify(data));
            this.coreService.UserSub.next(data);
            // Navigate to the dashboard page after successful login
            this.router.navigate(["/dashboard"]);
          } else {
            // Alert the user if there's an error during login
            alert(data?.error);
          }
        },
        (error) => {
          // Handle errors during login
          if (error.status === 422) {
            alert(JSON.stringify(error?.error?.errors));
          } else {
            alert(JSON.stringify(error?.error?.errors));
          }
        },
      );
  }

  // Method to set GuestLogin value based on the user input
  Guestlogin(value: boolean) {
    this.GuestLogin = value;
  }

  // Method to open the login information popup
  LoginInfo() {
    this.pageModel.isInfoPopup = true;
    this.modalService.open(this.errorinfo, {
      centered: true,
      scrollable: true,
    });
  }

  SkipLogin() {
    this.temp_user = {
      id: "0",
      firstName: "temp_user",
      lastName: "",
      userName: "",
      phoneNumber: "",
      password: "",
      email: "",
      token: "temp_token",
      dialcode: "",
      account_verified: 0,
      phoneNumberLength: 0,
      guest_access_allowed: 0,
    };

    localStorage.setItem("currentUser", JSON.stringify(this.temp_user));
    this.coreService.UserSub.next(this.temp_user);

    this.router.navigate(["/dashboard"]);
  }
}
